<mat-expansion-panel
  [expanded]="isExpanded"
  (closed)="panelClosed.emit(true)"
  (opened)="panelOpened.emit(true)"
  >
  <mat-expansion-panel-header
    class="panel-header"
    collapsedHeight="auto"
    expandedHeight="auto"
  >
    <mat-panel-title>
      <div class="status-indicator">
        @switch (panelStatus) {
          @case (panelStatusEnum.NotStarted) {
            <span>
              {{ panelNumber }}.
            </span>
          }
          @case (panelStatusEnum.Incomplete) {
            <span class="incomplete">
              <fa-duotone-icon
                [icon]="['fad', 'exclamation-circle']"
              ></fa-duotone-icon>
            </span>
          }
          @case (panelStatusEnum.Complete) {
            <span class="complete">
              <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </span>
          }
        }
      </div>

      {{ panelHeader }}
    </mat-panel-title>
    @if (panelDescription) {
      <mat-panel-description>
        {{ panelDescription }}
      </mat-panel-description>
    }
  </mat-expansion-panel-header>
  <div class="panel-details" [class.default-padding]="applyDefaultPadding">
    <ng-content></ng-content>
  </div>

  <div class="panel-action">
    <ng-content select="[panelAction]"></ng-content>
  </div>

  <ng-content select="[panelNotes]"></ng-content>
</mat-expansion-panel>
